import React from 'react';
import { isNil } from 'lodash';
import { FiCopy, FiEdit } from 'react-icons/fi';
import TableColumnTitle from '../../../../../../components/_table/TableColumnTitle';
import { setDateFormat } from '../../../../../../lib/moment';
import {
  HOME_TYPE,
  WIDGET_LAYOUT_TYPE_TEXT,
  WIDGET_TYPE_TEXT,
} from '../../../../../../constants/service/app/widgetConstants';
import SwitchForm from '../../../../../../components/form/SwitchForm';
import { setWidgetExposurePeriod } from '../../../../../../lib/utils/widgetUtils';
import { reDirectPage, setDash, setDetailPageUrl, openNewWindow } from '../../../../../../lib/common';
import { WIDGET_COPY_URL_PATH, WIDGET_EDIT_URL_PATH } from '../../../../../../constants/service/common/urlConstants';
import Anchor from '../../../../../../components/link/Anchor';

/**
 *  위젯 컬림
 */
export const columns = (data) => {
  const { onChangeWidgetStatus, getWidgetPreviewData, homeType } = data;

  return [
    {
      title: <TableColumnTitle title={'수정'} />,
      dataIndex: 'edit',
      render: (value, record) =>
        record.id ? (
          <FiEdit
            onClick={() =>
              reDirectPage({
                path: setDetailPageUrl(WIDGET_EDIT_URL_PATH, record.id),
                state: {
                  widgetType: record.widgetType,
                },
              })
            }
          />
        ) : (
          '-'
        ),
    },
    {
      title: <TableColumnTitle title={'복사'} />,
      dataIndex: 'copy',
      render: (value, record) =>
        record.id ? (
          <FiCopy
            onClick={() =>
              reDirectPage({
                path: setDetailPageUrl(WIDGET_COPY_URL_PATH, record.id),
                state: {
                  widgetType: record.widgetType,
                },
              })
            }
          />
        ) : (
          '-'
        ),
    },
    {
      title: <TableColumnTitle title={'노출 순서'} />,
      dataIndex: 'no',
      render: (value, record, index) =>
        record.id ? (homeType === HOME_TYPE.SUB || index === 0 ? index + 1 : index) : '-',
    },
    {
      title: <TableColumnTitle title={'활성화'} />,
      dataIndex: 'status',
      render: (value, record, index) =>
        record.id ? (
          <SwitchForm
            checked={!!value}
            disabled={homeType === HOME_TYPE.MAIN && index === 0}
            onChange={(value) =>
              onChangeWidgetStatus({
                widgetId: record.id,
                index,
                status: value ? 1 : 0,
              })
            }
          />
        ) : (
          '-'
        ),
    },
    {
      title: <TableColumnTitle title={'위젯 ID'} />,
      dataIndex: 'id',
      render: (value, record) =>
        record.id ? (
          <Anchor
            color="primary"
            isUnderLine
            text={value}
            onClick={() => openNewWindow(setDetailPageUrl(WIDGET_EDIT_URL_PATH, value))}
          />
        ) : (
          '-'
        ),
    },
    {
      title: <TableColumnTitle title={'위젯 타입'} />,
      dataIndex: 'widgetType',
      render: (value, record) =>
        record.id ? (
          <Anchor
            color="primary"
            isUnderLine
            text={WIDGET_TYPE_TEXT[value]}
            onClick={() =>
              getWidgetPreviewData({
                widgetId: record.id,
              })
            }
          />
        ) : (
          '-'
        ),
    },
    {
      title: <TableColumnTitle title={'레이아웃 타입'} />,
      dataIndex: 'layoutType',
      render: (value, record) => (!isNil(record.widgetType) ? WIDGET_LAYOUT_TYPE_TEXT[record.widgetType][value] : '-'),
    },
    {
      title: <TableColumnTitle title={'메인 타이틀'} />,
      dataIndex: 'mainTitle',
      render: (value) => setDash(value),
    },
    {
      title: <TableColumnTitle title={'서브 타이틀'} />,
      dataIndex: 'subTitle',
      render: (value) => setDash(value),
    },
    {
      title: <TableColumnTitle title={'메모'} />,
      dataIndex: 'memo',
      ellipsis: true,
      width: 200,
      render: (value) => setDash(value),
    },
    {
      title: <TableColumnTitle title={'노출기간'} />,
      dataIndex: 'exposurePeriod',
      render: (value, record) =>
        record.id ? setWidgetExposurePeriod(record.exposureStartDate, record.exposureEndDate) : '-',
    },
    {
      title: <TableColumnTitle title={'생성일'} />,
      dataIndex: 'createDate',
      render: (value) => setDateFormat(value),
    },
  ];
};
